import nookies from "nookies";
import jwt_decode from "jwt-decode";

import { TOKEN_STORAGE_KEY } from "./storeAuthorization";
import { NextPageContext } from "next";

export interface Token {
  efolioOzId?: string;
  scope?: string[];
}

const getAuthorization = (ctx?: NextPageContext) => {
  const cookies = nookies.get(ctx);

  const token = cookies?.[TOKEN_STORAGE_KEY];

  return {
    token,
    scope: token && jwt_decode<Token>(token)?.scope,
    efolioOzId: token && jwt_decode<Token>(token)?.efolioOzId
  };
};

export default getAuthorization;
